import { z } from 'zod';

/**
 * Zod-validate `import.meta.env` at module load. Bad/missing env → the
 * bundle throws at boot instead of leaking `undefined` into a request
 * later. All three values are PUBLIC (they ship in the browser bundle);
 * the anon key is RLS-gated by Supabase.
 */
const envSchema = z.object({
  VITE_SUPABASE_URL: z.string().url(),
  VITE_SUPABASE_ANON_KEY: z.string().min(1),
  VITE_WORKER_URL: z.string().url(),
});

export const env = envSchema.parse({
  VITE_SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL,
  VITE_SUPABASE_ANON_KEY: import.meta.env.VITE_SUPABASE_ANON_KEY,
  VITE_WORKER_URL: import.meta.env.VITE_WORKER_URL,
});

export type Env = z.infer<typeof envSchema>;
